import React, { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { errMessage } from "@/lib/api";

export function ChangePassword({ onChanged }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) return setError("New password must be at least 8 characters.");
    if (next !== confirm) return setError("New passwords don't match.");
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success(r.data.signed_out ? `Password changed. ${r.data.signed_out} other device${r.data.signed_out === 1 ? " was" : "s were"} signed out.` : "Password changed.");
      setCurrent(""); setNext(""); setConfirm("");
      onChanged?.();
    } catch (err) { setError(errMessage(err)); }
    finally { setBusy(false); }
  };

  return (
    <Card className="mt-6 border-slate-200 shadow-sm" data-testid="change-password-card">
      <CardContent className="p-6">
        <h2 className="text-base font-semibold text-slate-900">Change password</h2>
        <p className="mt-1 text-sm text-slate-600">Changing your password signs you out on every other device.</p>
        <form onSubmit={submit} className="mt-4 space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="cp-current">Current password</Label>
            <Input id="cp-current" type="password" autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="cp-current" />
          </div>
          <div className="grid gap-3 sm:grid-cols-2">
            <div className="space-y-1.5">
              <Label htmlFor="cp-new">New password</Label>
              <Input id="cp-new" type="password" autoComplete="new-password" required value={next} onChange={(e) => setNext(e.target.value)} data-testid="cp-new" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="cp-confirm">Confirm new password</Label>
              <Input id="cp-confirm" type="password" autoComplete="new-password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" />
            </div>
          </div>
          {error && <p className="text-sm text-red-600" role="alert" data-testid="cp-error">{error}</p>}
          <Button type="submit" disabled={busy} className="bg-[#0A2540] text-white hover:bg-[#0c2e4e]" data-testid="cp-submit">
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <KeyRound className="mr-2 h-4 w-4" />} Change password
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
